import { fn } from '@storybook/test';
import {FAQ} from "./FAQ";

export default {
    title: 'Extensions/FAQ',
    component: FAQ,
    parameters: {
        layout: 'centered',
    },
    tags: ['autodocs']
};

export const Default = {
    args: {
        tags: [
            { text: 'Online Exclusive', color: '#2f2828', textColor: 'white' },
            { text: 'Sale', color: 'red', textColor: 'white' },
        ]
    },
};




